
export class Result<T> implements Result<T>{
  Value: T;
  HasError: boolean;
  HasAlert: boolean;
  ErrorMessage: string;
  AlertMessage: string;
  Log: string;
  Logs: Array<string>;
  CustomErrorCode: string;
}

export class PagedResult <T> extends Result < T > {
  TotalItemCount: number;
}
